import Image from 'next/image'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {
	Icon as CIcon,
	type IconSize,
} from '@/_new-code/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/imageLoader'
import type {IconWithTextContentItem} from '@/_new-code/products/flexible-web-toolkit/blocks/icon-with-text'
import type {Block} from '@/_new-code/services/kontent-ai/types'
import {RichTextRenderer} from '@/_new-code/products/flexible-web-toolkit/components/rich-text-renderer'
import {customBrandChoices} from '../helpers'
import {KeyInfoModuleColumns as ClKeyInfoModuleColumns} from './key-info-module-columns'

export type KeyInfoModuleColumnsContentItem = IContentItem<{
	title: Elements.TextElement
	iconsWithText: Elements.LinkedItemsElement<IconWithTextContentItem>
}>

export const KeyInfoModuleColumnsBlock: Block<
	KeyInfoModuleColumnsContentItem
> = ({block, ...context}) => {
	return (
		<div>
			{block.elements.title ? (
				<h2
					className="text-center"
					data-kontent-element-codename="title"
				>
					{block.elements.title}
				</h2>
			) : null}
			<ClKeyInfoModuleColumns className="bg-white py-6 text-black lg:px-14 lg:py-12">
				{block.elements.iconsWithText.map((icon) => (
					<div
						className="flex"
						data-kontent-item-id={icon.system.id}
						key={icon.system.id}
						role="listitem"
					>
						{icon.elements.icon[0] ? (
							<CIcon
								brand={
									icon.elements.brand[0]?.codename &&
									customBrandChoices.includes(
										icon.elements.brand[0]?.codename
									)
										? 'none'
										: icon.elements.brand[0]?.codename ||
											'none'
								}
								noBorder
								size={
									(icon.elements.iconSize[0]?.codename ||
										'xs') as IconSize
								}
							>
								<div
									className="relative h-full w-full"
									data-kontent-element-codename="icon"
								>
									<Image
										alt={
											icon.elements.icon[0].description ??
											''
										}
										data-kontent-element-codename="icon"
										fill
										loader={loadImageFromKontentAI}
										src={icon.elements.icon[0].url}
									/>
								</div>
							</CIcon>
						) : null}

						<div className="ml-5 w-full">
							{icon.elements.title ? (
								<strong
									className="mb-2 inline-block"
									data-kontent-element-codename="title"
								>
									{icon.elements.title}
								</strong>
							) : null}
							<RichTextRenderer
								element={icon.elements.description}
								{...context}
							/>
						</div>
					</div>
				))}
			</ClKeyInfoModuleColumns>
		</div>
	)
}
